import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import normalize from 'json-api-normalizer';
import build from 'redux-object';

//Hooks
import useApi from '../Hooks/useApiGlobal';
import { updateGlobalStorePage } from '../Store/action';

//components
import Metatags from '../Layout/metas-tags/meta-tags';
import Univers from "../Components/univers"
import SliderLarge from "../Components/sliderLarge"
import { Loader } from "../Components/loader";
import ListBrands from "../Components/carouselBrands2"
import CarouselActus from "../Components/carouselActus";

const TemplateHome = ({ _uid }) => {

    let dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateGlobalStorePage('home'));
    }, [dispatch]); // isLoaded

    // Breakpoint
    const { desktop } = useSelector(state => state.breakpoint);

    const [paths, setPaths] = useState([]);
    const [dataRedux, setDataRedux] = useState();
    //Requete pour récup les infos de la page spéciale
    const [dataFetch, isLoaded] = useApi({
        name: 'api/node/special',
        _uid: _uid,
        include: 'content_config_form_files',
        fields: '&fields[node--special]=metatag,title,field_special_configformref,content_config_form_files',
        method: 'get'
    });

    useEffect(() => {
        if (isLoaded && dataFetch) {
            const normalizeJson = normalize(dataFetch.data);//Normalisation du json
            setDataRedux(build(normalizeJson, 'nodeSpecial', _uid));

            // console.log('dataFetch Home', dataFetch.data)
            setPaths(dataFetch.data.data.attributes.field_special_configformref.paths);
        }
    }, [isLoaded, dataFetch]); // eslint-disable-line

    //Requete qui permet de recup les landings + Mosaic (New Version pour gerer l'ordre sur les 2 en meme temps)
    const [contentRedux, setContentRedux] = useState([]);//Infos actu des marques
    const [dataFetchContent, isLoadedContent] = useApi({
        name: 'api/brands-actus-slider-homepage',
        include: 'field_common_pgph_ban.field_respimg_img_mobile,field_common_pgph_ban.field_respimg_img_desktop,field_landing_img_mob_thumbnail,field_landing_img_desk_thumbnail,field_landing_meanews_img_desk, field_landing_meanews_img_mob,field_landing_othernews_img_desk, field_landing_othernews_img_mob',
        method: 'get',
    });

    useEffect(() => {
        if (dataFetchContent && isLoadedContent) {
            if (dataFetchContent.data.data) {
                dataFetchContent.data.data.forEach((item, index) => {
                    item.truetype = item.type;
                    item.type = "node--content";
                })
            }
            const normalizeJsonActu = normalize(dataFetchContent.data);//Normalisation du json
            let dataFetchActuNormalize = build(normalizeJsonActu, 'nodeContent');
            setContentRedux(dataFetchActuNormalize);
        }
    }, [dataFetchContent, isLoadedContent])


    //Requete pour récup la liste des marques ayant une page dédiée
    const [brandsRedux, setBrandsRedux] = useState([]);//Infos Liste des marques
    const [dataFetchBrands, isLoadedBrands] = useApi({
        name: 'api/node/brand_page',
        include: 'field_brand_img_logo,field_common_tr_brand',//field_common_tr_brand
        fields: '&fields[node--brand_page]=title,field_brand_img_logo,path,drupal_internal__nid,field_common_tr_brand',
        sort: '&sort[sort-weight][path]=field_common_tr_brand.weight',
        method: 'get',
        limit: 250
    });
    useEffect(() => {
        if (isLoadedBrands && dataFetchBrands) {
            const normalizeJsonBrands = normalize(dataFetchBrands.data);//Normalisation du json
            setBrandsRedux(build(normalizeJsonBrands, 'nodeBrandPage'));
        }
    }, [isLoadedBrands, dataFetchBrands]);//chargement requete ok

    const renderPage = () => {
        const { metatag, title, contentConfigFormFiles: fullCarouselImages, fieldSpecialConfigformref: { data: { slider: { main: fullCarousel }, rubrics: categories, blocTextHomepage: blocText } } } = dataRedux;

        // const categoriesLink = Object.values(dataRedux.fieldSpecialConfigformref.paths);

        const getLink = (value) => {
            let link = paths[value];
            return link;
        };

        //-- Tracking
        let pageviewEvent = {
            category: 'Page d\'accueil',
            category2: '',
            category3: ''
        };

        return (
            <>
                {metatag && <Metatags listMeta={metatag} pageviewEvent={pageviewEvent} />}

                <SliderLarge carousel={fullCarousel} images={fullCarouselImages} desktop={desktop} name={title} />

                <div className="container">
                    <div className="c-univers">
                        {categories[0] &&
                            <Univers type="universEconomy" styleType="smaller--" target={getLink(categories[0].link)}
                                targetTitle={categories[0].title} index={categories[0].index}>
                                <strong dangerouslySetInnerHTML={{ __html: categories[0].title }} />
                                <p dangerouslySetInnerHTML={{ __html: categories[0].text }} />
                            </Univers>
                        }
                        {categories[1] &&
                            <Univers type="universTips" styleType="smaller--" target={getLink(categories[1].link)}
                                targetTitle={categories[1].title} index={categories[1].index}>
                                <strong dangerouslySetInnerHTML={{ __html: categories[1].title }} />
                                <p dangerouslySetInnerHTML={{ __html: categories[1].text }} />
                            </Univers>
                        }
                        {categories[2] &&
                            <Univers type="universBrands" styleType="smaller--" target={getLink(categories[2].link)}
                                targetTitle={categories[2].title} index={categories[2].index}>
                                <strong dangerouslySetInnerHTML={{ __html: categories[2].title }} />
                                <p dangerouslySetInnerHTML={{ __html: categories[2].text }} />
                            </Univers>
                        }
                        {categories[3] ?
                            <Univers type="universCommunity" styleType="smaller--" target={getLink(categories[3].link)}
                                targetTitle={categories[3].title} index={categories[3].index}>
                                <strong dangerouslySetInnerHTML={{ __html: categories[3].title }} />
                                <p dangerouslySetInnerHTML={{ __html: categories[3].text }} />
                            </Univers>
                            :
                            <Univers type="universCommunity" styleType="smaller--">
                                <strong dangerouslySetInnerHTML={{ __html: "Bientôt disponible" }} />
                            </Univers>
                        }
                    </div>
                </div>

                {(contentRedux && contentRedux.length > 0) &&
                    <div className="container2 c-carouselActus2Box">
                        <h2 className="section-title">Nos actualités de marques</h2>
                        <CarouselActus carousel={contentRedux} desktop={desktop} needSlider={false} />
                    </div>
                }

                {(brandsRedux && brandsRedux.length > 0) &&
                    <div className="container2">
                        <h2 className="section-title">Découvrez toutes nos marques</h2>
                        <ListBrands desktop={desktop} carousel={brandsRedux} />
                    </div>
                }

                {(blocText && (blocText.title || blocText.text)) &&
                    <div className="container2">
                        <div className="c-mentions">
                            {
                                blocText.title && <h2 className="section-title">{blocText.title}</h2>
                            }
                            {
                                blocText.text && <p dangerouslySetInnerHTML={{ __html: blocText.text.value }}></p>
                            }
                        </div>
                    </div>
                }


            </>
        )
    };
    return (isLoaded && dataRedux) ? renderPage() : <Loader />
};

export default TemplateHome;